module.exports = __webpack_public_path__ + "assets/img/activity_newuser_bg.514348c6.png";